import React, { FC } from 'react';
import { IViewResolverLiteProps, ViewResolverLite } from '@ldp/view-resolver-lite';
import { useRendererCallbackMap, useRendererMap, useSkeletonMap } from '../../hooks';

/** Don't forget to add prop types */
export interface IViewResolverSdmInnerProps
  extends Omit<IViewResolverLiteProps, 'rendererMap' | 'skeletonMap' | 'rendererCbMap' | 'isFederated'> {
  children?: React.ReactNode;
  baseFont?: number;
  designTokenPlatform?: string;
}

/** Inner component which allows the hooks to access common context props */
export const ViewResolverSdmInner: FC<IViewResolverSdmInnerProps> = ({
  children,
  baseFont = 12,
  designTokenPlatform = 'web',
  ...props
}) => {
  const skeletonMap = useSkeletonMap();
  const rendererMap = useRendererMap();
  const rendererCbMap = useRendererCallbackMap();
  return (
    <ViewResolverLite
      skeletonMap={skeletonMap}
      rendererMap={rendererMap}
      rendererCbMap={rendererCbMap}
      isFederated={false}
      baseFont={baseFont}
      designTokenPlatform={designTokenPlatform}
      {...props}
    >
      {children}
    </ViewResolverLite>
  );
};

export default ViewResolverSdmInner;
